import { capabilitySentences } from '../lib/format'
import type { Capabilities } from '../lib/types'

/** What this booking system can do, in sentences a park owner can read. */
export default function CapabilityList({ capabilities }: { capabilities: Capabilities }) {
  const items = capabilitySentences(capabilities)

  return (
    <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 0.5rem', columns: 2, columnGap: '1.5rem' }}>
      {items.map((item) => (
        <li key={item.key} className={item.on ? undefined : 'muted'} style={{ breakInside: 'avoid' }}>
          <i className={`dot ${item.on ? 'fresh' : 'off'}`} aria-hidden="true" style={{ marginRight: '0.4rem' }} />
          {item.label}
        </li>
      ))}
    </ul>
  )
}
